<template>
    <div class="scroll-nav" :hidden="!showImage">
        <div class="scroll-nav-content"> 
            <div>
                <NavBar/>
            </div>
        </div>
    </div>
</template>
  
<script>
import NavBar from '@/components/NavBar.vue'
export default {
    components: {
      NavBar
    },
    data() {
      return {
        showImage: false,
        scrollThreshold: 300 // 滚动到 500px 时显示图片
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop >= this.scrollThreshold) {
          this.showImage = true;
        } else {
          this.showImage = false;
        }
      }
    }
};
</script>
  
<style lang="scss" scoped> 

@media screen and (max-width: 767px){
    // .scroll-nav-content{
        // height: 7rem!important;
        // div{
            // width: 90%!important; 
        // }
    // }  
}

.scroll-nav { 
    position: fixed;
    top: 0;
    z-index: 999;
    background-color:#040435 ; 
    width: 100%; 
    max-width: 100%;
    .scroll-nav-content{
        position: relative;
        display: block;
        height: 60px; 
        width: 100%;
        max-width: 100%;
        padding-top: 10px;
        
        div { 
            max-width: 100%;
            margin: auto; 
        }
        
    }
} 
</style>